const QuantityInput = () => {

	document.addEventListener('alpine:init', () => {
		// Quantity Dropdown Component
		Alpine.data('quantityDropdown', (initialValue = 1) => ({
						selectedValue: initialValue,
						isOpen: false,

						toggle() {
										this.isOpen = !this.isOpen;
						},

						close() {
										this.isOpen = false;
						},

						selectValue(value) {
										this.selectedValue = value;
										this.close();

										// Trigger change event for WooCommerce
										this.$nextTick(() => {
														const selectElement = this.$el.querySelector('select');
														if (selectElement) {
																		selectElement.dispatchEvent(new Event('change', { bubbles: true }));
														}
										});
						}
		}));
	});
};

export default QuantityInput;
